CTAMap.map = {
  obj: null,
  markerClusterer: null,
  trips: {},
  filterIds: null,
  selectedTrip: null,
  overlay: null,
  currentMarker: null,
  loadedQuadrants: [],
  recommendedClusters: [],
  markerHighlight: {
    list: {},
    current: null,
    singleMarker: null,
  },
};

CTAMap.map.ini = function () {
  //get first location to display
  var lat, lng, zoom;
  if (
    ys &&
    ys.cycling_trips &&
    ys.cycling_trips.coordinates &&
    ys.cycling_trips.coordinates.lat !== false &&
    ys.cycling_trips.coordinates.lng !== false
  ) {
    //approximate location
    lat = parseFloat(ys.cycling_trips.coordinates.lat);
    lng = parseFloat(ys.cycling_trips.coordinates.lng);
    CTAMap.map.setCurrentMarker(lat, lng);
    zoom = 11;
  } else {
    //europe
    lat = 54.5259614;
    lng = 15.2551187;
    zoom = 3;
  }

  CTAMap.map.obj = new google.maps.Map(
    document.getElementById('mapContainer'),
    {
      mapTypeId: google.maps.MapTypeId.TERRAIN,
      styles: window.ys.cycling_trips.map.styles,
      center: { lat: lat, lng: lng },
      zoom: zoom,
      zoomControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
    }
  );
  CTAMap.map.overlay = new google.maps.OverlayView();
  CTAMap.map.overlay.draw = function () {};
  CTAMap.map.overlay.setMap(CTAMap.map.obj);

  var listener = google.maps.event.addListener(
    CTAMap.map.obj,
    'idle',
    function () {
      CTAMap.map.overlay.getPanes();
      CTAMap.map.overlay.getProjection();
      google.maps.event.removeListener(listener);
    }
  );

  google.maps.event.addListener(CTAMap.map.obj, 'zoom_changed', function () {
    CTAMap.map.removeSimpleInfoWindows();
  });

  var mapIdleTimeout = null;
  google.maps.event.addListener(CTAMap.map.obj, 'idle', function () {
    if (mapIdleTimeout === null) {
      google.maps.event.trigger(CTAMap.map.obj, 'idle_start');
    }
    clearTimeout(mapIdleTimeout);
    mapIdleTimeout = setTimeout(function () {
      google.maps.event.trigger(CTAMap.map.obj, 'idle_end');
      mapIdleTimeout = null;
    }, 50);
  });

  CTAMap.queue.disableUntilMapIdle();

  CTAMap.map.obj.controls[google.maps.ControlPosition.TOP_LEFT].push(
    CyclingTrips.prototype.getZoomControl(CTAMap.map.obj)[0]
  );

  CTAMap.map.obj.addListener('zoom_changed', function () {
    CTAMap.map.viewChanged();
  });

  CTAMap.map.obj.addListener('center_changed', function () {
    CTAMap.map.viewChanged();
  });

  google.maps.event.addListener(CTAMap.map.obj, 'idle_start', function () {
    jQuery('#mapContainer .siw').hide();
  });

  google.maps.event.addListener(CTAMap.map.obj, 'idle_end', function () {
    setTimeout(function () {
      CTAMap.map.recalculateInfoWindow();
    }, 200);
  });

  var mcOptions = {
    imagePath:
      'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
    cssClass: 'group-icon',
    gridSize: 100,
    styles: [
      {
        textColor: '#78faae',
        anchor: [0, 0],
        url: window.ys.cycling_trips.icons.group_marker,
        textSize: 19,
        height: 48,
        width: 48,
        backgroundPosition: '0px 0px',
        backgroundColor: '#161718',
        borderRadius: 40,
      },
      {
        textColor: '#78faae',
        anchor: [0, 0],
        url: window.ys.cycling_trips.icons.group_marker,
        textSize: 19,
        height: 48,
        width: 48,
        backgroundPosition: '0px 0px',
        backgroundColor: '#161718',
        borderRadius: 40,
      },
      {
        textColor: '#78faae',
        anchor: [0, 0],
        url: window.ys.cycling_trips.icons.group_marker,
        textSize: 19,
        height: 48,
        width: 48,
        backgroundPosition: '0px 0px',
        backgroundColor: '#161718',
        borderRadius: 40,
      },
    ],
  };

  CTAMap.map.markerClusterer = new MarkerClusterer(
    CTAMap.map.obj,
    [],
    mcOptions
  );
  CTAMap.map.checkSupportOfGeolocation();
};

CTAMap.map.viewChanged = function () {
  if (!CTAMap.queue.disabled) {
    CTAMap.api.setArgsFromMap();
    CTAMap.queue.start(true);
  }

  CTAMap.map.recalculateClusters();
};

CTAMap.map.markerHighlight.ini = function (ids) {
  CTAMap.map.waitUntilClustersDefined(function () {
    for (
      var cKey = 0;
      cKey < CTAMap.map.markerClusterer.clusters_.length;
      cKey++
    ) {
      for (
        var mKey = 0;
        mKey < CTAMap.map.markerClusterer.clusters_[cKey].markers_.length;
        mKey++
      ) {
        var cPostId =
          CTAMap.map.markerClusterer.clusters_[cKey].markers_[mKey].postId;
        if (ids.indexOf(cPostId) !== false) {
          if (CTAMap.map.markerClusterer.clusters_[cKey].markers_.length > 1) {
            var obj = jQuery(
              CTAMap.map.markerClusterer.clusters_[cKey].clusterIcon_.div_
            );
            CTAMap.map.markerHighlight.list[cPostId] = {
              type: 'group',
              object: obj,
              top: obj.position().top,
              cluster: cKey,
            };

            if (CTAMap.map.trips[cPostId].recommended) {
              if (!CTAMap.map.recommendedClusters.includes(cKey)) {
                CTAMap.map.recommendedClusters.push(cKey);
              }
              CTAMap.map.markerHighlight.setClusterImage(
                cPostId,
                'group_marker_recommended'
              );
              CTAMap.map.markerHighlight.setClusterTextColor(
                cPostId,
                '#0e3a2f'
              );
            }
          } else {
            CTAMap.map.markerHighlight.list[cPostId] = {
              type: 'single',
            };
          }
        }
      }
    }
  });
};

CTAMap.map.markerHighlight.clear = function () {
  CTAMap.map.markerHighlight.stop();
  CTAMap.map.markerHighlight.list = {};
};

CTAMap.map.markerHighlight.start = function (postId) {
  if (
    typeof CTAMap.map.markerHighlight.list[postId] === 'undefined' ||
    typeof postId === 'undefined'
  ) {
    if (CTA.debug) {
      console.log('Error: start bouncing marker - marker not found');
    }
    return;
  }
  if (CTAMap.map.selectedTrip && postId === CTAMap.map.selectedTrip.id) {
    return;
  }

  CTAMap.map.markerHighlight.current = postId;

  //start bouncing single marker
  if (CTAMap.map.markerHighlight.list[postId].type === 'single') {
    CTAMap.map.markerHighlight.startSingle();
  }

  //start bouncing with cluster
  if (CTAMap.map.markerHighlight.list[postId].type === 'group') {
    CTAMap.map.markerHighlight.startCluster();
  }
};

CTAMap.map.markerHighlight.stop = function () {
  if (!CTAMap.map.markerHighlight.current) {
    return;
  }
  if (
    CTAMap.map.markerHighlight.list[CTAMap.map.markerHighlight.current].type ===
    'single'
  ) {
    CTAMap.map.markerHighlight.stopSingle();
  }

  if (
    CTAMap.map.markerHighlight.list[CTAMap.map.markerHighlight.current].type ===
    'group'
  ) {
    CTAMap.map.markerHighlight.stopCluster();
  }

  CTAMap.map.markerHighlight.current = null;
};

CTAMap.map.markerHighlight.startSingle = function () {
  var markerImage = {
    url: CTAMap.map.trips[CTAMap.map.markerHighlight.current].recommended
      ? window.ys.cycling_trips.icons.bike_recommended_selected
      : window.ys.cycling_trips.icons.bike_selected,
    scaledSize: new google.maps.Size(62, 62),
  };

  CTAMap.map.markerHighlight.singleMarker = new google.maps.Marker({
    position: {
      lat: CTAMap.map.trips[CTAMap.map.markerHighlight.current].start
        .getPosition()
        .lat(),
      lng: CTAMap.map.trips[CTAMap.map.markerHighlight.current].start
        .getPosition()
        .lng(),
    },
    icon: markerImage,
    optimized: false,
    zIndex: 1100,
    postId: CTAMap.map.markerHighlight.current,
    visible: true,
    map: CTAMap.map.obj,
  });
};

CTAMap.map.markerHighlight.stopSingle = function () {
  if (CTAMap.map.markerHighlight.singleMarker) {
    CTAMap.map.markerHighlight.singleMarker.setMap(null);
  }
};

CTAMap.map.markerHighlight.startCluster = function () {
  var isRecommended = CTAMap.map.recommendedClusters.includes(
    CTAMap.map.markerHighlight.list[CTAMap.map.markerHighlight.current].cluster
  );
  var icon = isRecommended ? 'group_marker_recommended' : 'group_marker';
  CTAMap.map.markerHighlight.setClusterImage(
    CTAMap.map.markerHighlight.current,
    icon
  );
};

CTAMap.map.markerHighlight.stopCluster = function () {
  var isRecommended = CTAMap.map.recommendedClusters.includes(
    CTAMap.map.markerHighlight.list[CTAMap.map.markerHighlight.current].cluster
  );
  var icon = isRecommended ? 'group_marker_recommended' : 'group_marker';
  CTAMap.map.markerHighlight.setClusterImage(
    CTAMap.map.markerHighlight.current,
    icon
  );
};

CTAMap.map.markerHighlight.setClusterImage = function (postId, name) {
  CTAMap.map.markerHighlight.list[postId].object.css(
    'background-image',
    'url("' + window.ys.cycling_trips.icons[name] + '")'
  );
};

CTAMap.map.markerHighlight.setClusterTextColor = function (postId, color) {
  CTAMap.map.markerHighlight.list[postId].object.css('color', color);
};

CTAMap.map.doFilterIds = function (ids) {
  CTAMap.map.filterIds = ids;
  var postId;

  // ids exists but it is empty array = hide all
  if (typeof ids === 'object' && ids.length === 0) {
    for (postId in CTAMap.map.trips) {
      if (
        CTAMap.map.trips[postId].start &&
        CTAMap.map.trips[postId].start.visible
      ) {
        CTAMap.map.hideMarker(postId);
      }
    }
    CTAMap.map.markerRedraw();
    return;
  }

  // ids does not exist = show all
  if (typeof ids === 'undefined') {
    for (postId in CTAMap.map.trips) {
      if (
        CTAMap.map.trips[postId].start &&
        !CTAMap.map.trips[postId].start.visible
      ) {
        CTAMap.map.showMarker(postId);
      }
    }
    CTAMap.map.markerRedraw();
    return;
  }

  // ids exists and it is non-empty array
  for (postId in CTAMap.map.trips) {
    var postIdInt = parseInt(postId);
    if (!CTAMap.map.trips[postId].start) {
      continue;
    }
    if (ids.indexOf(postIdInt) === -1) {
      //hide
      if (CTAMap.map.trips[postId].start.visible) {
        CTAMap.map.hideMarker(postId);
      }
    } else {
      //show
      if (!CTAMap.map.trips[postId].start.visible) {
        CTAMap.map.showMarker(postId);
      }
    }
  }

  CTAMap.map.markerRedraw();
};

CTAMap.map.isVisible = function () {
  return jQuery('#mapContainer:visible').length > 0;
};

CTAMap.map.setCurrentMarker = function (lat, lng) {
  CTAMap.map.removeCurrentMarker();

  var markerImage = {
    url: window.ys.cycling_trips.icons.basic,
    scaledSize: new google.maps.Size(35, 35),
  };

  CTAMap.map.currentMarker = new google.maps.Marker({
    position: {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    },
    icon: markerImage,
    optimized: false,
    zIndex: 1000,
    map: CTAMap.map.obj,
  });
};

CTAMap.map.removeCurrentMarker = function () {
  if (CTAMap.map.currentMarker) {
    CTAMap.map.currentMarker.setMap(null);
  }
};

CTAMap.map.getRadius = function () {
  var bounds = CTAMap.map.obj.getBounds();

  if (!bounds) {
    return 0;
  }

  var center = bounds.getCenter();
  var ne = bounds.getNorthEast();

  // r = radius of the earth in km
  var r = 6371.0;

  // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
  var lat1 = center.lat() / 57.2958;
  var lon1 = center.lng() / 57.2958;
  var lat2 = ne.lat() / 57.2958;
  var lon2 = ne.lng() / 57.2958;

  // distance = circle radius from center to Northeast corner of bounds
  var dis =
    r *
    Math.acos(
      Math.sin(lat1) * Math.sin(lat2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
    );
  return dis;
};

CTAMap.map.setCurrentLocation = function () {
  CTAMap.view.showLoading();
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        CTAMap.map.setCurrentMarker(
          position.coords.latitude,
          position.coords.longitude
        );

        CTAMap.map.obj.setCenter(pos);
        CTAMap.map.obj.setZoom(11);
        GLSearch.setCoordinates(
          position.coords.latitude,
          position.coords.longitude
        );
      },
      function () {
        //user did not allow geolocation
        jQuery('.location-form-target').hide();
        CTAMap.view.hideLoading();
      }
    );
  } else {
    //browser doesn't support geolocation
    jQuery('.location-form-target').hide();
    CTAMap.view.hideLoading();
  }
};

CTAMap.map.fitBoundsAfterSearch = function (data) {
  if (CTAMap.api.requestType === 'place') {
    var bounds = new google.maps.LatLngBounds();
    var latlng = new google.maps.LatLng(
      CTAMap.api.args.lat,
      CTAMap.api.args.lng
    );
    bounds.extend(latlng);

    jQuery.each(data.results, function (index, route) {
      if (!route.kml || !route.kml.start) {
        return;
      }
      var latlng = new google.maps.LatLng(
        route.kml.start.lat,
        route.kml.start.lng
      );
      bounds.extend(latlng);
    });

    CTAMap.queue.disabled = true;
    var listener = google.maps.event.addListener(
      CTAMap.map.obj,
      'idle',
      function () {
        CTAMap.queue.disabled = false;
        google.maps.event.removeListener(listener);
      }
    );

    CTAMap.map.obj.fitBounds(bounds);
  }
};

CTAMap.map.checkSupportOfGeolocation = function () {
  if (!navigator.geolocation) {
    jQuery('.location-form-target').hide();
    CTAMap.view.hideLoading();
  }
};

CTAMap.map.getZoomControl = function () {
  var zoomInButton = '<a class="zoom-in">' + new WLCIcon('plus') + '</a>';
  var zoomOutButton = '<a class="zoom-out">' + new WLCIcon('minus') + '</a>';
  var element = jQuery(
    '<div class="zoom-controls">' +
      zoomInButton +
      '<div class="zoom-connector"></div>' +
      zoomOutButton +
      '</div>'
  );

  element.find('.zoom-in').click(function (e) {
    e.preventDefault();
    CTAMap.map.obj.setZoom(CTAMap.map.obj.getZoom() + 1);
  });

  element.find('.zoom-out').click(function (e) {
    e.preventDefault();
    CTAMap.map.obj.setZoom(CTAMap.map.obj.getZoom() - 1);
  });

  return element;
};

CTAMap.map.addMarker = function (data, type) {
  data.id = parseInt(data.id);

  type = typeof type !== 'string' ? 'bike' : type;

  if (
    CTAMap.map.trips[data.id] &&
    CTAMap.map.trips[data.id].start &&
    CTAMap.map.trips[data.id].kml
  ) {
    //  return;
  }

  var markerImage = {
    //url: recommended ? window.ys.cycling_trips.icons.bike_recommended : window.ys.cycling_trips.icons.bike,
    url: window.ys.cycling_trips.icons[type],
    scaledSize: new google.maps.Size(62, 62),
  };

  var marker = new google.maps.Marker({
    position: {
      lat: parseFloat(data.lat),
      lng: parseFloat(data.lng),
    },
    icon: markerImage,
    optimized: false,
    zIndex: 1000,
    postId: data.id,
    visible: false,
    map: null,
  });

  var kml = new google.maps.KmlLayer(data.kml, {
    suppressInfoWindows: true,
    preserveViewport: true,
    map: null,
    clickable: false,
  });

  if (!CTAMap.map.trips[data.id]) {
    CTAMap.map.trips[data.id] = {};
  }

  CTAMap.map.trips[data.id].start = marker;
  CTAMap.map.trips[data.id].kml = kml;
  CTAMap.map.trips[data.id].type = type;
  CTAMap.map.trips[data.id].recommended = type === 'bike_recommended';

  CTAMap.map.trips[data.id].start.addListener('mouseover', function () {
    if (
      CTAMap.map.selectedTrip !== null &&
      CTAMap.map.selectedTrip.id === data.id
    ) {
    } else {
      CTAMap.map.trips[data.id].kml.setMap(CTAMap.map.obj);
    }

    if (
      CTAMap.map.selectedTrip !== null &&
      CTAMap.map.selectedTrip.id !== data.id
    ) {
      CTAMap.map.trips[CTAMap.map.selectedTrip.id].kml.setMap(null);
    }
  });

  CTAMap.map.trips[data.id].start.addListener('mouseout', function () {
    if (CTAMap.map.selectedTrip && CTAMap.map.selectedTrip.id !== data.id) {
      CTAMap.map.trips[data.id].kml.setMap(null);
    }

    if (CTAMap.map.selectedTrip === null) {
      CTAMap.map.trips[data.id].kml.setMap(null);
    }

    if (
      CTAMap.map.selectedTrip !== null &&
      CTAMap.map.selectedTrip.id !== data.id
    ) {
      CTAMap.map.trips[CTAMap.map.selectedTrip.id].kml.setMap(CTAMap.map.obj);
    }
  });

  CTAMap.map.trips[data.id].start.addListener('click', function () {
    CTAMap.map.removeSimpleInfoWindows();
    if (CTAMap.map.selectedTrip) {
      //remove kml if there is selected trip
      CTAMap.map.trips[CTAMap.map.selectedTrip.id].kml.setMap(null);
    }
    CTAMap.map.selectedTrip = data;
    if (CTAMap.map.markerIsVisible(marker)) {
      if (CTAMap.map.trips[data.id].html) {
        //if is loaded already
        CTAMap.map.createSimpleInfoWindow(
          marker,
          CTAMap.map.trips[data.id].html,
          CTAMap.map.trips[data.id].recommended,
          function () {
            CTAMap.map.selectedTrip = null;
            CTAMap.map.trips[data.id].kml.setMap(null);
          }
        );
      } else {
        //if is not loaded - get the detail
        var request = CTAMap.api.getDetail(data.id);
        request.done(function (response) {
          CTAMap.map.trips[data.id].html = response.html;
          CTAMap.map.createSimpleInfoWindow(
            marker,
            response.html,
            CTAMap.map.trips[data.id].recommended,
            function () {
              CTAMap.map.selectedTrip = null;
              CTAMap.map.trips[data.id].kml.setMap(null);
            }
          );
        });
      }
    }
  });

  //  if(!CTAMap.map.filterIds || (CTAMap.map.filterIds && CTAMap.map.filterIds.indexOf(data.id) !== -1)){
  //      CTAMap.map.showMarker(data.id);
  //  }

  //if a trip is selected
  if (CTAMap.map.selectedTrip && CTAMap.map.selectedTrip.id === data.id) {
    setTimeout(function () {
      if (CTAMap.map.markerIsVisible(marker)) {
        google.maps.event.trigger(CTAMap.map.trips[data.id].start, 'click');
        CTAMap.map.trips[data.id].kml.setMap(CTAMap.map.obj);
      } else {
      }
    }, 100);
  }
};

CTAMap.map.showMarker = function (postId) {
  if (CTAMap.map.trips[postId]) {
    CTAMap.map.trips[postId].start.setMap(CTAMap.map.obj);
    CTAMap.map.trips[postId].start.visible = true;
    CTAMap.map.markerClusterer.addMarker(
      CTAMap.map.trips[postId].start,
      'bike_recommended'
    );
  } else if (CTA.debug) {
    console.log('Error - trying to show not existing marker ' + postId);
  }
};

CTAMap.map.hideMarker = function (postId) {
  if (CTAMap.map.trips[postId]) {
    CTAMap.map.trips[postId].start.visible = false;
    CTAMap.map.markerClusterer.removeMarker(
      CTAMap.map.trips[postId].start,
      true
    );
  } else if (CTA.debug) {
    console.log('Error - trying to hide not existing marker ' + postId);
  }
};

CTAMap.map.markerRedraw = function () {
  CTAMap.map.markerClusterer.resetViewport();
  CTAMap.map.markerClusterer.redraw();
};

CTAMap.map.addMarkerHtml = function (id, html) {
  if (!CTAMap.map.trips[id]) {
    CTAMap.map.trips[id] = {};
  }

  if (!CTAMap.map.trips[id].html) {
    CTAMap.map.trips[id].html = html;
  }
};

CTAMap.map.createSimpleInfoWindow = function (
  marker,
  html,
  recommended,
  onClose
) {
  var panes = CTAMap.map.overlay.getPanes();
  var xy = CTAMap.map.overlay
    .getProjection()
    .fromLatLngToDivPixel(marker.getPosition());
  var mapXy = CTAMap.map.overlay
    .getProjection()
    .fromLatLngToDivPixel(CTAMap.map.obj.getBounds().getSouthWest());
  var icon = recommended
    ? window.ys.cycling_trips.icons.bike_bordered_recommended
    : window.ys.cycling_trips.icons.bike_bordered;
  panes.floatPane.appendChild(
    jQuery(
      '<div class="siw" data-lat="' +
        marker.getPosition().lat() +
        '" data-lng="' +
        marker.getPosition().lng() +
        '" style="top:' +
        xy.y +
        'px;left:' +
        xy.x +
        'px;">' +
        '<div class="siw-content">' +
        html +
        '<a class="siw-close">' +
        new WLCIcon('cross_circle') +
        '</a>' +
        '<img class="siw-img" src="' +
        icon +
        '" alt="marker">' +
        '</div>' +
        '</div>'
    )[0]
  );
  var width = jQuery('#mapContainer .siw-content').outerWidth();
  if (mapXy.x > xy.x - width) {
    //move with map if infowindow is (partialy) hidden
    var moveBy = -1 * (mapXy.x - (xy.x - width) + 10);
    CTAMap.queue.disableUntilMapIdle();
    CTAMap.map.obj.panBy(moveBy, 0);
  }
  jQuery('#mapContainer .siw-close').click(function (e) {
    e.preventDefault();
    var t = jQuery(this);
    t.parents('.siw').remove();
    onClose();
  });
};

CTAMap.map.recalculateClusters = function () {};

CTAMap.map.recalculateInfoWindow = function () {
  var infoWindow = jQuery('#mapContainer .siw');
  infoWindow.show();
  var postId = parseInt(infoWindow.find('article').attr('data-id'));
  if (postId) {
    var lat = infoWindow.attr('data-lat');
    var lng = infoWindow.attr('data-lng');
    var xy = CTAMap.map.overlay.getProjection().fromLatLngToDivPixel({
      lat: function () {
        return parseFloat(lat);
      },
      lng: function () {
        return parseFloat(lng);
      },
    });
    infoWindow.css({ top: xy.y + 'px', left: xy.x + 'px' });
  }
};

CTAMap.map.removeSimpleInfoWindows = function () {
  jQuery('#mapContainer .siw').remove();
};

CTAMap.map.markerIsVisible = function (marker) {
  return typeof marker.internalPosition !== 'undefined';
};

CTAMap.map.markerIsInCluster = function (postId) {
  for (var i = 0; i < CTAMap.map.markerClusterer.clusters_.length; i++) {
    var clusterMarkers = CTAMap.map.markerClusterer.clusters_[i].getMarkers();
    for (var j = 0; j < clusterMarkers.length; j++) {
      if (clusterMarkers[j].postId === postId) {
        if (clusterMarkers.length === 1) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

CTAMap.map.hideTrips = function (exclude) {
  var e = typeof exclude !== 'undefined' ? exclude : [];

  for (var post_id in CTAMap.map.trips) {
    if (e.indexOf(parseInt(post_id)) === -1) {
      CTAMap.map.trips[post_id].kml.setMap(null);
    }
  }
};

CTAMap.map.removeAllElements = function () {
  for (var post_id in CTAMap.map.trips) {
    CTAMap.map.markerClusterer.removeMarker(CTAMap.map.trips[post_id].start);
    CTAMap.map.trips[post_id].start.setMap(null);
    CTAMap.map.trips[post_id].kml.setMap(null);
  }

  //CTAMap.map.trips = {};
};
CTAMap.map.waitUntilClustersDefined = function (callback) {
  function callMe() {
    CTAMap.map.waitUntilClustersDefined(callback);
  }

  for (var i = 0; i < CTAMap.map.markerClusterer.clusters_.length; i++) {
    if (CTAMap.map.markerClusterer.clusters_[i].clusterIcon_.div_ === null) {
      setTimeout(callMe, 100);
      return;
    }
  }
  callback();
};

CTAMap.map.animateTop = function (obj, from, to, ms, callback) {
  function move(obj, current, to, msPerPixel, pixelsPerMove) {
    setTimeout(function () {
      var add;
      if (current > to) {
        add = -1 * pixelsPerMove;
        current += add;
        obj.css({ top: current + 'px' });
        if (current > to) {
          move(obj, current, to, msPerPixel, pixelsPerMove);
        } else {
          callback();
        }
      } else {
        add = pixelsPerMove;
        current += add;
        obj.css({ top: current + 'px' });
        if (current < to) {
          move(obj, current, to, msPerPixel, pixelsPerMove);
        } else {
          callback();
        }
      }
    }, msPerPixel);
  }

  var delta = Math.abs(from - to);
  var msPerPixel = ms / delta;
  var pixelsPerMove = 1;
  if (msPerPixel < 10) {
    pixelsPerMove = (10 * 1) / msPerPixel;
    msPerPixel = 10;
  }
  obj.css({ top: from + 'px' });
  move(obj, from, to, msPerPixel, pixelsPerMove);
};
